import React from "react";
import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Inicio from "./pages/proveedor/Inicio";
import AAFF from "./pages/proveedor/AAFF";
// import AAFFComunidades from "./pages/admin/AAFFComunidades";
import Comunidades from "./pages/proveedor/Comunidades";
import Comunidad from "./pages/proveedor/Comunidad";
import Proveedor from "./pages/proveedor/Proveedor";
import DetallesAAFF from "./pages/proveedor/DetallesAAFF";
import DatosPerfil from "../components/perfil/datosPerfil";
import { Icon, Building2, Wrench } from "lucide-react";
import { houses } from '@lucide/lab';

export function RouteBundle() {
  return (
    <Routes>
      <Route path="/" element={<Inicio />} />
      <Route path="/aaff" element={<AAFF />} />
      <Route path="aaff/:nif/comunidades" element={<DetallesAAFF />} />
      {/* <Route path="/aaff/:nif/comunidades" element={<AAFFComunidades />} /> */}
      <Route path="/comunidades" element={<Comunidades />} />
      <Route path="/aaff/:nif/comunidades/:nifFinca" element={<Comunidad />} />
      <Route path="/proveedor" element={<Proveedor />} />
      <Route path="/perfil" element={<DatosPerfil />} />
      <Route path="*" element={<Navigate to='/' replace/>}/>
    </Routes>
  );
}

const refrescoLocal = () => {
  localStorage.setItem("hasReloaded", "true");
}

export function MenuLinksClientes(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink
          activeclassname="active"
          to="/proveedor"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
            color: props.showSidebar ? "#33383b" : "#fff",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Wrench stroke-width="1.5" alt={t('clients.mainPanel')} />{t('clients.mainPanel')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          activeclassname="active"
          to="/aaff"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Building2 stroke-width="1.5" alt={t('clients.aaff')} />{t('clients.aaff')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          activeclassname="active"
          to="/comunidades"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Icon iconNode={houses} stroke-width="1.5" alt={t('clients.communities')} />{t('clients.communities')}
          </div>
        </NavLink>
      </li>
    </>
  );
}
